import './sentry';
import './styles/global.css';

import ReactDOM from 'react-dom/client';

import App from './App';

ReactDOM.createRoot(document.getElementById('mainNode') as HTMLElement).render(
  <App />,
);
